"use client";

import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import { pushDataLayer } from "@/lib/data-layer";

export default function GTMPageTracker() {
  const pathname = usePathname();
  // URL della pagina precedente in-app; al primo pageview cade su document.referrer.
  const previousUrl = useRef<string>("");

  useEffect(() => {
    if (typeof window !== "undefined" && window.dataLayer) {
      const pageType = pathname.split("/")[1] || "home";
      pushDataLayer({
        event: "virtual_pageview",
        page_path: pathname,
        page_title: document.title,
        page_type: pageType,
        page_referrer: previousUrl.current || document.referrer,
      });

      previousUrl.current = window.location.href;
    }
  }, [pathname]);

  return null;
}
